import { MessageSquare, Trash2, Plus } from "lucide-react"
import { useAiConversations, useDeleteAiConversation } from "@/hooks/use-ai-conversations"
import { useAiStore } from "@/stores/ai-store"
import { useAiChat } from "@/hooks/use-ai-chat"

interface AiConversationListProps {
  onBack: () => void
}

export function AiConversationList({ onBack }: AiConversationListProps) {
  const { data } = useAiConversations()
  const deleteMutation = useDeleteAiConversation()
  const { activeConversationId, setActiveConversation } = useAiStore()
  const { startNewChat } = useAiChat()

  const conversations = data?.data || []

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between border-b border-border px-4 py-2.5">
        <button
          onClick={onBack}
          className="text-xs text-muted-foreground transition-colors hover:text-foreground"
        >
          ← Wróć
        </button>
        <button
          onClick={() => {
            startNewChat()
            onBack()
          }}
          className="flex items-center gap-1 text-xs text-primary transition-colors hover:opacity-80"
        >
          <Plus size={12} />
          Nowa rozmowa
        </button>
      </div>

      <div className="flex-1 overflow-y-auto">
        {conversations.length === 0 ? (
          <div className="px-4 py-8 text-center">
            <MessageSquare size={24} className="mx-auto mb-2 text-muted-foreground opacity-30" />
            <p className="text-xs text-muted-foreground">Brak historii rozmów</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <div
              key={conv.id}
              className={`group flex items-center gap-2 border-b border-border px-4 py-2.5 transition-colors hover:bg-muted/30 ${
                conv.id === activeConversationId ? "bg-muted/50" : ""
              }`}
            >
              <button
                onClick={() => {
                  setActiveConversation(conv.id)
                  onBack()
                }}
                className="min-w-0 flex-1 text-left"
              >
                <p className="truncate text-sm text-foreground">
                  {conv.title || "Nowa rozmowa"}
                </p>
                <p className="text-[10px] text-muted-foreground">
                  {conv.message_count} wiad. ·{" "}
                  {conv.last_message_at
                    ? new Date(conv.last_message_at).toLocaleDateString("pl")
                    : ""}
                </p>
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation()
                  if (conv.id === activeConversationId) setActiveConversation(null)
                  deleteMutation.mutate(conv.id)
                }}
                className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded opacity-0 transition-opacity hover:bg-red-100 hover:text-red-500 group-hover:opacity-100 dark:hover:bg-red-900/30"
              >
                <Trash2 size={12} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
